import { useEffect, useState } from "react"
import Select, { SingleValue } from "react-select"
import { VesselSegment } from "user/userService"
import { SaveToLocalStorage } from "../../user/userSlice"
import { useItineraryContext } from "modules/PortPredictor/hooks/itineraryContext"
import { Button } from "react-bootstrap"

export type ImoNumber = string

export interface VesselListSingle {
  label: string
  value: ImoNumber
}

export interface VesselSegmentInputSelection {
  label: string
  value: VesselSegment
}

export interface ChosenVesselForSelect {
  imo: number
  segment?: string
}

export interface SelectOption {
  label: string
  value: string
}
interface VesselSearchProps {
  vesselsData: VesselListSingle[] | undefined
  getVesselsLoading: boolean
  getChosenVesselLoading: boolean
  getChosenVessel: ({ name, imo }: { imo: number; name: string }) => void
  setChosenSegment: (segment: VesselSegmentInputSelection) => void
  getVessels: ({ segment }: { segment: string }) => void
  vesselSegments: VesselSegment[] //VesselSegmentInputSelection[]
  defaultVessel: SelectOption
  realVesselSegment: VesselSegmentInputSelection | null
  onClickReset: () => void
  setRealVesselSegment: (segment: VesselSegmentInputSelection) => void
}

export function VesselSearch({
  vesselsData,
  getVesselsLoading,
  getChosenVessel,
  setChosenSegment,
  getVessels,
  vesselSegments,
  defaultVessel,
  realVesselSegment,
  setRealVesselSegment,
  onClickReset,
}: VesselSearchProps) {
  const { getTabStateKeyValue } = useItineraryContext()
  const [chosenVessel, setChosenVessel] = useState<SelectOption | undefined>(
    defaultVessel
  )

  const vesselSegmentsForDropdown = vesselSegments.map((segment) => {
    if (segment === VesselSegment.Capesize) {
      return {
        label: `${VesselSegment.Capesize}`,
        value: segment,
      }
    }
    if (segment === VesselSegment.Handysize) {
      return {
        label: `${VesselSegment.Handysize}`,
        value: segment,
      }
    }
    if (segment === VesselSegment.Panamax) {
      return {
        label: `${VesselSegment.Panamax}`,
        value: segment,
      }
    }
    if (segment === VesselSegment.Supramax) {
      return {
        label: `${VesselSegment.Supramax}`,
        value: segment,
      }
    }
    return {
      label: `${VesselSegment.Panamax}`,
      value: segment,
    }
  })

  useEffect(() => {
    setChosenVessel(defaultVessel)
  }, [defaultVessel])

  return (
    <div className="VesselSearch_Col w-100 VesselSearch_Col--left d-flex flex-column ">
      <div className="d-flex pb-2">
        <h5 className="VesselSearch_Col VesselSearch_Title mb-0">
          Search Vessel
        </h5>
        <Button
          className="VesselSearch_Button VesselSearch_Col"
          onClick={() => {
            onClickReset()
          }}
          color="primary"
        >
          Reset
        </Button>
      </div>
      <div className="VesselSearch_SearchVesselInputs">
        <Select
          isDisabled={getVesselsLoading || !getTabStateKeyValue("isEditMode")}
          className="VesselSearch_Name"
          options={vesselsData}
          value={chosenVessel?.value ? chosenVessel : null}
          placeholder={
            getVesselsLoading && realVesselSegment
              ? `Loading ${realVesselSegment.label} vessels...`
              : "Search by Vessel Name / IMO Number"
          }
          onChange={(vessel: SingleValue<SelectOption>) => {
            if (!vessel) {
              return
            }
            setChosenVessel(vessel)
            getChosenVessel({ name: vessel.label, imo: Number(vessel.value) })
          }}
        />

        <div className="VesselSearch_Segment">
          <Select
            isDisabled={!getTabStateKeyValue("isEditMode")}
            defaultValue={realVesselSegment}
            options={vesselSegmentsForDropdown}
            value={realVesselSegment}
            onChange={(segment: SingleValue<VesselSegmentInputSelection>) => {
              if (!segment) {
                return
              }
              setChosenVessel(undefined)
              setChosenSegment(segment)
              setRealVesselSegment(segment)
              SaveToLocalStorage("defaultSegment", segment.value)
              getVessels({ segment: segment.value })
            }}
          />
        </div>
      </div>
    </div>
  )
}
